import { GetServerSidePropsContext } from 'next';
import { ParsedUrlQuery } from 'querystring';

import initializeApollo, { addApolloState } from 'apollo-client';

import LayoutConfines from 'components/layout/LayoutConfines';
import PageMeta, { defaultMeta } from 'components/layout/PageMeta';

import VideoPlayer from 'components/common/VideoPlayer';
import VideoInfo from 'components/library/VideoInfo';

import { useVideo, getVideoSsr } from 'hooks/content/useVideo';

import { NotFoundStatusCode } from 'utils/constants';

import { ContentType } from 'graphql/types';

interface IProps {
  slug: string;
}

export default function VideoContent({ slug }: IProps) {
  const { data } = useVideo(slug);

  const video = data?.videoBySlug as ContentType;

  return (
    <>
      <PageMeta
        title={`${video?.title} - Российское Общество «Знание»` || ''}
        description={video?.description || ''}
        image={video?.coverUrl || ''}
        canonicalHref={`${defaultMeta.canonicalHref}/library/video/${video?.slug}`}
      />
      <VideoPlayer
        url={video.videoUrl!}
        isAvailable
        coverUrl={video.coverUrl || ''}
      />
      <LayoutConfines>
        <VideoInfo data={video} />
      </LayoutConfines>
    </>
  );
}

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const { slug } = ctx.params as ParsedUrlQuery;
  const apolloClient = initializeApollo();

  await getVideoSsr(ctx, apolloClient, slug as string);

  return addApolloState(apolloClient, {
    props: {
      slug,
    },
    notFound: ctx.res.statusCode === NotFoundStatusCode,
  });
}
